
<app-blog-header></app-blog-header>
<!--banner start-->
<section class="banner blog-banner">
	<div class="container">
		<div class="banner-content text-center">
			<h1>News and Insights about<br>Homes, Living & Energy</h1>
			<h6>We deliver perspective on topics that directly impact life, honestly.</h6>
			
			<div class="col-md-10 offset-md-1 col-12 text-center mt-4 px-0">
			<!-- <form name="form" (ngSubmit)="createAccount($event,f , f.form.valid);" #f="ngForm" novalidate>
				<div class="col-12 p-0">
				<div class="form-group input-group flex-wrap">
				  <input type="text" class="form-control" placeholder="EMAIL ADDRESS" 
				  aria-label="Email Address" name="email" [(ngModel)]="userObj.emailId" 
				  #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" aria-describedby="button-addon" 
				  style="font-size:16px;font-family: 'Calibre-Bold'; color:#2b2e34 !important;" 
				  pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$">
				  <div class="form-group input-group-append mb-0">
						<button class="btn btn-primary" id="button-addon">SUBSCRIBE</button>
					  </div>

				  <div class="invalid-feedback posabs col-12 p-0">
						<div class="boxcolour" *ngIf="f.submitted && email.invalid && email.errors && email.errors.required">
						  <span _ngcontent-c8="" class="fa fa-exclamation-circle mr-1" type="Icon"></span>Email is required</div>
						<div [hidden]="email.valid || email.pristine || !email.errors.pattern || userObj.emailId !== ''" class="boxcolour">
						  <span _ngcontent-c8="" class="fa fa-exclamation-circle mr-1" type="Icon"></span>Please enter a valid email
						</div>
					  </div>
					</div>
					
				 
				</div>
				<div class="mt-2" *ngIf="msg"><p class="subscribe">{{msg}}</p></div>
				<div class="mt-3"><p>Join our exclusive mailing list and let’s stay connected.</p></div>				
			</form> -->
			<form name="form" (ngSubmit)="createAccount($event,f , f.form.valid);" #f="ngForm" novalidate>
				<div class="form-group input-group flex-wrap mb-0 mt-sm-5">
					<input type="text" class="form-control" placeholder="EMAIL ADDRESS" aria-label="Email Address" aria-describedby="button-addon" style="font-size:16px; font-family: 'Calibre-Bold'; color:#555555 !important; height: 36px !important"
					name="email" [(ngModel)]="userObj.emailId" 
									#email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
										required email pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$">
					<div class="form-group input-group-append mb-0">
					<button class="btn btn-primary" id="button-addon">SUBSCRIBE</button>
					</div>
					<div class="invalid-feedback posabs">
					<div class="boxcolour" *ngIf="f.submitted && email.invalid && email.errors && email.errors.required">
						<span _ngcontent-c8="" class="fa fa-exclamation-circle mr-1" type="Icon"></span>Email is required</div>
					<div [hidden]="email.valid || email.pristine || !email.errors.pattern" class="boxcolour">
						<span _ngcontent-c8="" class="fa fa-exclamation-circle mr-1" type="Icon"></span>Please enter a valid email
					</div>
					</div>
				</div>
				<div class="invalid-feedback posabs">
					<div class="boxcolour" *ngIf="f.submitted && email.invalid && email.errors && email.errors.required">
						<span class="fa fa-exclamation-circle mr-1" type="Icon"></span>Email is required</div>
					<div [hidden]="email.valid || email.pristine || !email.errors.pattern" class="boxcolour">
						<span _ngcontent-c8="" class="fa fa-exclamation-circle mr-1" type="Icon"></span>Please enter a valid email
					</div>
					</div>
					<div class="mt-2" *ngIf="msg"><p class="subscribe">{{msg}}</p></div>
				<div><p class="mb-0">Join our exclusive mailing list and let’s stay connected.</p></div>
			</form>
			</div>
		</div>
	</div>
</section>
	<!--banner end-->

	<div class="container footerbtm">
	
	<div class="row search-box py-sm-4">
		<div class="col-md-8 col-12 px-4" id="custom-search-input">
			<div class="input-group">
            <input class="form-control py-2 border-right-0 border-bottom search-box" type="search" placeholder="SEARCH" id="myInput" (keyup)="searchBar($event)">
            <span class="input-group-append">
                <div class="input-group-text bg-transparent"><i class="fa fa-search"></i></div>
            </span>
        </div>
		</div>
	</div>
	
	<!--blocks start-->
	<div id="myUL">
		<div *ngFor="let blog of blogsList; let i = index">
			<div class="row mt-4 pt-1 blog-cards" *ngIf="i % 3 == 0">
				<div class="col-md-12 d-flex px-0">
					<div class="col-md-4" *ngIf="i < blogsList.length">
						<div class="card mb-2 shadow h-100">
							<img class="card-img-top" src="{{blogsList[i].article_img}}" alt="{{blogsList[i].article_description}}" title="{{blogsList[i].article_title}}" (click)="articleNavigate(i + 1)">
							<div class="card-body">
								<h5 class="card-title" (click)="articleNavigate(i + 1)">{{blogsList[i].article_header}}</h5>
								<p class="card-text">{{blogsList[i].article_sub_header}}</p>
								<a (click)="articleNavigate(i + 1)" class="btn btn-sm readmore"><span>... Read More</span></a>
								<div class="tags-group">
									<p class="tags" *ngFor="let tag of blogsList[i].tags" (click)="showSerched(tag)">{{tag}}</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-4" *ngIf="i + 1 < blogsList.length">
						<div class="card mb-2 shadow h-100">
							<img class="card-img-top" src="{{blogsList[i + 1].article_img}}" alt="{{blogsList[i + 1].article_description}}" title="{{blogsList[i + 1].article_title}}" (click)="articleNavigate(i+2)">
							<div class="card-body">
								<h5 class="card-title" (click)="articleNavigate(i+2)">{{blogsList[i + 1].article_header}}</h5>
								<p class="card-text">{{blogsList[i + 1].article_sub_header}}</p>
								<a (click)="articleNavigate(i+2)" class="btn btn-sm readmore"><span>... Read More</span></a>
								<div class="tags-group">
									<p class="tags" *ngFor="let tag of blogsList[i + 1].tags" (click)="showSerched(tag)">{{tag}}</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-4" *ngIf="i + 2 < blogsList.length">
						<div class="card mb-2 shadow h-100">
							<img class="card-img-top" src="{{blogsList[i + 2].article_img}}" alt="{{blogsList[i + 2].article_description}}" title="{{blogsList[i + 2].article_title}}" (click)="articleNavigate(i+3)">
							<div class="card-body">
								<h5 class="card-title" (click)="articleNavigate(i+3)">{{blogsList[i + 2].article_header}}</h5>
								<p class="card-text">{{blogsList[i + 2].article_sub_header}}</p>
								<a (click)="articleNavigate(i+3)" class="btn btn-sm readmore"><span>... Read More</span></a>
								<div class="tags-group">
									<p class="tags" *ngFor="let tag of blogsList[i+2].tags" (click)="showSerched(tag)">{{tag}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!--blocks end-->
	
	</div>

   <app-blog-footer></app-blog-footer>
   